export default __webpack_public_path__ + "portfolio03.jpg";